import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function GetEmailList() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/nylas/email-list/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function GetDepartmentSingleRow(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/department/get-department-row/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-Lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}
